import { Component, inject, OnInit } from '@angular/core'
import { UserService } from '../../services/user.service'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { environment } from '../../../environments/environment'
import { PaginationComponent } from '../template/pagination/pagination.component'
import { debounceTime, Subject } from 'rxjs'

@Component({
  selector: 'app-birthdays',
  imports: [CommonModule, FormsModule, PaginationComponent],
  templateUrl: './birthdays.component.html',
  styleUrl: './birthdays.component.scss'
})
export class BirthdaysComponent implements OnInit {
  birthdayList: any[] = []
  search = ''
  pageLimit = 10
  currentPage = 1
  totalCount = 0
  public apiEndpoint = environment.apiBaseUrl
  private userService = inject(UserService)
  private searchSubject = new Subject<string>()

  get pageLastRecord(): number {
    return Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  ngOnInit() {
    this.loadBirthdays()
    this.searchSubject.pipe(debounceTime(400)).subscribe(() => {
      this.currentPage = 1
      this.loadBirthdays()
    })
  }

  loadBirthdays() {
    const params = {
      page: this.currentPage,
      limit: this.pageLimit,
      search: this.search?.trim() || undefined
    }

    this.userService.getCelebrations(params).subscribe((res: any) => {
      if (res.type === 'all') {
        this.birthdayList = res.data
        this.totalCount = res.total
      }
    })
  }

  onFilterChange() {
    this.searchSubject.next(this.search)
  }

  onPageChange(page: number) {
    this.currentPage = page
    this.loadBirthdays()
  }

  sendBirthdayWish(userId: string) {
    console.log('Send wish to', userId)
  }
  isTodayBirthday(dateStr: string): boolean {
    if (!dateStr) return false

    const today = new Date()
    const birth = new Date(dateStr)

    return birth.getDate() === today.getDate() && birth.getMonth() === today.getMonth()
  }
}
